import { render, staticRenderFns } from "./UpdateTrainer.vue?vue&type=template&id=53d95d66"
import script from "./UpdateTrainer.vue?vue&type=script&lang=js"
export * from "./UpdateTrainer.vue?vue&type=script&lang=js"
import style0 from "./UpdateTrainer.vue?vue&type=style&index=0&id=53d95d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports